import { render, staticRenderFns } from "./BetList.vue?vue&type=template&id=5bd9c1d5&scoped=true"
import script from "./BetList.vue?vue&type=script&lang=js"
export * from "./BetList.vue?vue&type=script&lang=js"
import style0 from "./BetList.vue?vue&type=style&index=0&id=5bd9c1d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9c1d5",
  null
  
)

export default component.exports